require('./ie11Polyfills.js');
import angular from 'angular';
import agGrid from 'ag-grid';

// redux
import uiRouter from 'angular-ui-router';
import ngRedux from 'ng-redux';
import ngReduxUiRouter from 'redux-ui-router';

// config
import reduxConfig from './config/reduxConfig';
import routeConfig from './config/routeConfig';

// wrapper directive
import wrapper from './directives/datacenterWrapper';

agGrid.initialiseAgGridWithAngular1(angular);

// core directives
import datacenterServices from './services/services';
import datacenterDirectives from './directives/directives';
import datacenterFilters from './filters/filters';

const mainModule = angular
  .module('datacenterMain', [
    uiRouter,
    ngRedux,
    ngReduxUiRouter,
    'ngAnimate',
    'ngSanitize',
    'agGrid',
    datacenterServices,
    datacenterDirectives,
    datacenterFilters,
  ]);

mainModule.directive('datacenterWrapper', wrapper);

mainModule.config(['$locationProvider', ($locationProvider) => {
  $locationProvider.hashPrefix('!');
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false,
  });
}]);

mainModule.config(routeConfig());

mainModule.config(reduxConfig);

mainModule.run();

export default mainModule;



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/main.js
 **/